import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "rows", "placeholder", "disabled"]

import { computed, nextTick, onMounted, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TextArea',
  props: {
    modelValue: { default: '' },
    rows: { default: 1 },
    placeholder: { default: '' },
    disabled: { type: Boolean, default: false },
    autoResize: { type: Boolean, default: true },
    textareaClass: { default: '' },
    variant: { default: 'default' }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "keydown", "click", "keyup", "scroll"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const textareaRef = ref<HTMLTextAreaElement | null>(null);

const shellClasses = computed(() => [
  'ui-text-area',
  `ui-text-area--${props.variant}`,
  {
    'ui-text-area--disabled': props.disabled
  }
]);

function resize(): void {
  if (!props.autoResize || !textareaRef.value) {
    return;
  }

  textareaRef.value.style.height = 'auto';
  textareaRef.value.style.height = `${textareaRef.value.scrollHeight}px`;
}

function focus(): void {
  textareaRef.value?.focus();
}

function setSelectionRange(start: number, end: number): void {
  textareaRef.value?.setSelectionRange(start, end);
}

function handleInput(event: Event): void {
  const target = event.target as HTMLTextAreaElement;
  emit('update:modelValue', target.value);
  emit('input', event);
  resize();
}

watch(() => props.modelValue, async () => {
  await nextTick();
  resize();
});

onMounted(() => {
  resize();
});

__expose({
  focus,
  resize,
  setSelectionRange,
  textareaRef
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(shellClasses.value)
  }, [
    _renderSlot(_ctx.$slots, "before"),
    _createElementVNode("textarea", {
      ref_key: "textareaRef",
      ref: textareaRef,
      value: __props.modelValue,
      rows: __props.rows,
      placeholder: __props.placeholder,
      disabled: __props.disabled,
      class: _normalizeClass(['ui-text-area__control', __props.textareaClass]),
      onInput: handleInput,
      onFocus: _cache[0] || (_cache[0] = ($event: any) => (emit('focus', $event))),
      onBlur: _cache[1] || (_cache[1] = ($event: any) => (emit('blur', $event))),
      onKeydown: _cache[2] || (_cache[2] = ($event: any) => (emit('keydown', $event))),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('click', $event))),
      onKeyup: _cache[4] || (_cache[4] = ($event: any) => (emit('keyup', $event))),
      onScroll: _cache[5] || (_cache[5] = ($event: any) => (emit('scroll', $event)))
    }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1),
    _renderSlot(_ctx.$slots, "after")
  ], 2 /* CLASS */))
}
}

})